import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { equals as e } from "./arrayUtils.js";
import t from "./has.js";
import { isInt8Array as n, isUint8Array as o, isUint8ClampedArray as r, isInt16Array as i, isUint16Array as f, isInt32Array as s, isUint32Array as c, isFloat32Array as a, isFloat64Array as u, slice as p } from "./typedArrayUtil.js";

function y(e, t) {
  var n;
  if (t) for (n in e) {
    e.hasOwnProperty(n) && (void 0 === e[n] ? delete e[n] : e[n] instanceof Object && y(e[n], !0));
  } else for (n in e) {
    e.hasOwnProperty(n) && void 0 === e[n] && delete e[n];
  }
  return e;
}

function l(e) {
  if (!e || "object" != typeof e || "function" == typeof e) return e;
  if (n(e) || o(e) || r(e) || i(e) || f(e) || s(e) || c(e) || a(e) || u(e)) return p(e);
  if (e instanceof Date) return new Date(e.getTime());

  if (e instanceof ArrayBuffer) {
    return e.slice(0, e.byteLength);
  }

  if (e instanceof Map) {
    var _t = new Map();

    return e.forEach(function (e, n) {
      _t.set(n, l(e));
    }), _t;
  }

  if (e instanceof Set) {
    var _t2 = new Set();

    return e.forEach(function (e) {
      _t2.add(l(e));
    }), _t2;
  }

  var t;
  var y = e;
  if ("function" == typeof y.clone) t = y.clone();else if ("function" == typeof y.map && "function" == typeof y.forEach) t = y.map(l);else if ("function" == typeof y.notifyChange && "function" == typeof y.watch) t = y.clone();else {
    t = {};

    var _iterator = _createForOfIteratorHelper(Object.getOwnPropertyNames(e)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _n = _step.value;
        t[_n] = l(e[_n]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return t;
}

function m(e, t) {
  return e === t || "number" == typeof e && isNaN(e) && "number" == typeof t && isNaN(t) || "function" == typeof (e || {}).getTime && "function" == typeof (t || {}).getTime && e.getTime() === t.getTime() || !1;
}

function g(t, n) {
  return t === n || (null == t || "string" == typeof t ? t === n : "number" == typeof t ? t === n || "number" == typeof n && isNaN(t) && isNaN(n) : t instanceof Date ? n instanceof Date && t.getTime() === n.getTime() : Array.isArray(t) ? Array.isArray(n) && e(t, n) : t instanceof Set ? n instanceof Set && h(t, n) : t instanceof Map ? n instanceof Map && j(t, n) : "object" == typeof t && "object" == typeof n && b(t, n));
}

function b(e, t) {
  if (null === e || null === t) return !1;
  var n = Object.keys(e),
      o = n.length;
  if (null === t || Object.keys(t).length !== o) return !1;

  for (var _i = 0, _n2 = n; _i < _n2.length; _i++) {
    var _r = _n2[_i];
    if (e[_r] !== t[_r] || !Object.prototype.hasOwnProperty.call(t, _r)) return !1;
  }

  return !0;
}

function h(e, t) {
  if (e.size !== t.size) return !1;

  var _iterator2 = _createForOfIteratorHelper(e),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _n3 = _step2.value;
      if (!t.has(_n3)) return !1;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return !0;
}

function j(e, t) {
  if (e.size !== t.size) return !1;

  var _iterator3 = _createForOfIteratorHelper(e),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _step3$value = _slicedToArray(_step3.value, 2),
          _n4 = _step3$value[0],
          _o = _step3$value[1];

      var _e = t.get(_n4);

      if (_e !== _o || void 0 === _e && !t.has(_n4)) return !1;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return !0;
}

var O = function O() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  for (var _len = arguments.length, n = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    n[_key - 1] = arguments[_key];
  }

  return t("esri-deprecation-warnings") && console.warn("[esri.core.lang] 🛑 DEPRECATED - Function: mixin()\n\t🛠️ Replacement: Use Object.assign() directly\n\t⚙️ Version: 4.19"), Object.assign.apply(Object, [e].concat(n));
};

export { l as clone, m as equals, g as equalsShallow, y as fixJson, O as mixin };